import { render, staticRenderFns } from "./AnimationModel.vue?vue&type=template&id=3e4d0876&scoped=true"
import script from "./AnimationModel.vue?vue&type=script&lang=js"
export * from "./AnimationModel.vue?vue&type=script&lang=js"
import style0 from "./AnimationModel.vue?vue&type=style&index=0&id=3e4d0876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d0876",
  null
  
)

export default component.exports